// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2f0Rt","boxTitle":"Qualiphy_boxTitle__3ngmc","box":"Qualiphy_box__2Ly1G","toggleWrap":"Qualiphy_toggleWrap__2oGE5"};